import styled from "styled-components";

const ProductPrice = styled.div`
  padding-top: 0.3em;
  font-weight: 600;
  font-size: 28px;
`;
export default ProductPrice;
